





























import { defineComponent } from '@vue/composition-api';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';
import { TEXT_SIZE, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';
import completeImg from '@berlin-front/common/assets/complete.svg';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';
import { useContext } from '@berlin-front/common/composables/context';
import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { AtoneAuthCompleteContext } from './context';

export default defineComponent({
  name: 'CompleteView',
  components: {
    AppCard,
    AppContainer,
    AppRow,
    AppText,
    ModalHeader,
    HeaderContextConsumer: ModalHeaderContext.consumer,
  },

  setup() {
    const { useComplete } = useContext(AtoneAuthCompleteContext);

    useComplete();

    return {
      completeImg,
      TEXT_SIZE,
      TEXT_WEIGHT,
    };
  },
});
